import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { fetchMGGamesData, fetchMGPolasData } from '../../store/actions/mgGameAction';
import Loading from '../Loading';

const MicroGamingCard = (data) => {
  const dispatch = useDispatch();
  const { mgNames, mgImages, mgPolas, nameAndImagesIsLoading } = useSelector((state) => state.mgGameReducer);

  useEffect(() => {
    dispatch(fetchMGPolasData());
    dispatch(fetchMGGamesData());
  }, [dispatch]);

  if (data.isLoading || nameAndImagesIsLoading) return (
    <>
      <Loading />
    </>
  )

  return (
    <>
      <h2>Micro Gaming</h2>
      <section className="container px-3 sm:px-12 mx-auto" id="hb">
        <div className='grid grid-cols-2 lg:grid-cols-6 gap-4 justify-items-center'>
          {
            mgNames.map((mgName, i) => {
              return (
                <div key={i} className="w-full grid justify-items-center bg-item p-3">
                  <div className="relative flex-shrink-0">
                    <img width={"150px"} src={mgImages[i]} alt={mgName} />
                  </div>
                  <div className="grid box-content text-center content-center capitalize mb-3">
                    <span className="game-name h-12 grid content-center">{mgName}</span>
                    <div className="jam px-5 py-3 mb-3">
                      <span>Jam Gacor: </span>
                      <span className="jamGacor">
                        {data.jamGacors[i] ? data.jamGacors[i].value8 : ''}
                      </span>
                    </div>
                    <span>Pola: </span>
                    <span className="v">{mgPolas[i] ? `${mgPolas[i].value1} - ${mgPolas[i].value2} - ${mgPolas[i].value3}` : ''}</span>
                  </div>
                  <div className='single-bar relative items-center'>
                    <div className='absolute font-bold rtpValue' style={{ top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
                      <span>{data.rtps[i] ? data.rtps[i].value8 : ''}%</span>
                    </div>
                    <div className="single-bar__fill bar animated-gradient" style={{ width: `${data.rtps[i] ? data.rtps[i].value8 : ''}%` }}></div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </section >
    </>
  );
};

export default MicroGamingCard;